import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import { formatCoverLetter } from '../openai';

export async function exportToPDF(content: string): Promise<void> {
  try {
    // Send to ChatGPT for formatting while preserving exact content

    const formattedContent = (await formatCoverLetter({ content })).data || '';

    // Create PDF document
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([612, 792]); // US Letter
    const { width, height } = page.getSize();
    const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);

    // PDF styling
    const fontSize = 12;
    const lineHeight = fontSize * 1.15; // 1.15 line spacing
    const margin = 72; // 1 inch margins
    let currentY = height - margin;
    const maxWidth = width - margin * 2;

    // Split content into lines and draw text
    const lines = formattedContent.split('\n');
    for (const line of lines) {
      if (currentY < margin + lineHeight) {
        // Add new page if needed
        const newPage = pdfDoc.addPage([612, 792]);
        currentY = height - margin;
      }

      if (line.trim()) {
        // Calculate text width for proper wrapping
        const words = line.trim().split(' ');
        let currentLine = '';

        for (const word of words) {
          const testLine = currentLine + (currentLine ? ' ' : '') + word;
          const textWidth = font.widthOfTextAtSize(testLine, fontSize);

          if (textWidth > maxWidth) {
            page.drawText(currentLine, {
              x: margin,
              y: currentY,
              size: fontSize,
              font,
              color: rgb(0, 0, 0),
              lineHeight
            });
            currentY -= lineHeight;
            currentLine = word;
          } else {
            currentLine = testLine;
          }
        }

        if (currentLine) {
          page.drawText(currentLine, {
            x: margin,
            y: currentY,
            size: fontSize,
            font,
            color: rgb(0, 0, 0),
            lineHeight
          });
        }
      }
      currentY -= lineHeight;
    }

    // Save and download PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'cover_letter.pdf';
    document.body.appendChild(a);
    a.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    throw new Error('Failed to export to PDF');
  }
}
